export default "__VITE_ASSET__3K81$pxa__"